import { render } from "./search-product-component.vue?vue&type=template&id=55853011&scoped=true"
import script from "./search-product-component.vue?vue&type=script&lang=js"
export * from "./search-product-component.vue?vue&type=script&lang=js"

import "./search-product-component.vue?vue&type=style&index=0&id=55853011&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55853011"]])

export default __exports__